import { Stack } from "@mantine/core"
import { SectionHeader } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import { TranslationsEditor } from "./TranslationsEditor"

export const Translations = () => {
  const { t } = useTranslation("communicationStudio")

  return (
    <Stack gap="xs">
      <SectionHeader
        title={t("tabs.languages.translations.title")}
        subtitle={t("tabs.languages.translations.subtitle")}
        divider={true}
      />
      <Stack justify="space-between" w="fit-content">
        <TranslationsEditor />
      </Stack>
    </Stack>
  )
}
